import { IconFunctionalInformationCircleFilled16 } from '@cian/ui-kit';
import * as React from 'react';
import { Dispatch } from 'redux';

import { trackNewbuildingInfoLabelClick } from './tracking';
import { EGalleryLabelColor, IGalleryLabel } from '../../../../types/gallery-label';
import { openSellersInfoModal } from 'shared/actions/sellersInfoModal';

interface IGetNewbuildingMediaLabelsParams {
  id: number;
  dispatch: Dispatch;
}

export const getNewbuildingMediaLabels = ({ id, dispatch }: IGetNewbuildingMediaLabelsParams): IGalleryLabel[] => {
  return [
    {
      color: EGalleryLabelColor.Black,
      label: 'Первичная продажа',
      uiKitIcon: <IconFunctionalInformationCircleFilled16 color="current_color" />,
      onClick: (event: React.MouseEvent) => {
        event.preventDefault();
        event.stopPropagation();
        dispatch(openSellersInfoModal());
        trackNewbuildingInfoLabelClick(id);
      },
    },
  ];
};
